import React from 'react';
import { RouteComponentProps } from '@reach/router';
import { useMutation, useQuery } from '@apollo/client';
import { Box, Flex, Spinner, Switch, Text } from '@chakra-ui/react';

import Layout from '../../components/Layout';
import { useCustomToast } from '../../hooks/useCustomToast';
import { APP_FEATURES, AppFeature, AppFeaturesQuery, SET_APP_FEATURE } from './query';

interface AppFeaturesProps extends RouteComponentProps {}

const AppFeatures: React.FC<AppFeaturesProps> = () => {
  const toast = useCustomToast();
  const { data, loading, error, refetch } = useQuery<AppFeaturesQuery>(APP_FEATURES);
  const [setAppFeature, { loading: saving }] = useMutation(SET_APP_FEATURE);

  const onToggle = async (feature: AppFeature, enabled: boolean) => {
    try {
      await setAppFeature({
        variables: {
          key: feature.key,
          enabled,
        },
      });
      await refetch();
    } catch (mutationError) {
      toast({
        title: 'App Feature konnte nicht gespeichert werden.',
        description: mutationError instanceof Error ? mutationError.message : undefined,
        status: 'error',
      });
    }
  };

  return (
    <Layout>
      <Text as="h2" fontSize="4xl" fontWeight="bold" flex="1" fontFamily="heading" mb="8">
        App Features
      </Text>
      {loading ? (
        <Flex width="100%" justifyContent="center" alignItems="center" py="4">
          <Spinner />
        </Flex>
      ) : null}
      {error ? (
        <Flex width="100%" justifyContent="center" alignItems="center" py="4">
          Ein Fehler ist aufgetreten. Schreib Osamah an.
        </Flex>
      ) : null}
      {data?.appFeatures.map((feature) => (
        <Flex key={feature.key} alignItems="center" justifyContent="space-between" gap="6" py="4" borderBottomWidth="1px">
          <Box flex="1">
            <Text fontWeight="bold">{feature.title}</Text>
            <Text fontSize="sm">{feature.description}</Text>
          </Box>
          <Switch
            isChecked={feature.enabled}
            isDisabled={saving}
            colorScheme="green"
            onChange={(event) => onToggle(feature, event.target.checked)}
          />
        </Flex>
      ))}
    </Layout>
  );
};

export default AppFeatures;
